const SUFFIX = /,\s*United States\s*$/;

export const stripUnitedStatesSuffix = (value) => {
    if (typeof value !== 'string') {
        return value;
    }
    return value.replace(SUFFIX, '');
};

export default stripUnitedStatesSuffix;
